import React, { Fragment, useState, useCallback, useEffect } from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import { Btn } from '../../../../AbstractElements';
import HeaderProfile from './HeaderProfile';
import NavComponent from './NavComponent';
import TabComponent from './TabComponent';
import PromiseSpinner from '../../../../CommonElements/Spinner/PromiseSpinner';
import { trackPromise } from 'react-promise-tracker';
import { ProductListDesc, pinagareFilesUpload, pinagareAPIURL } from '../../../../Constant';
import { ToastContainer, toast } from "react-toastify";

const LeftContact = () => {
  const [activeTab, setActiveTab] = useState('1');
  const [isOpen, setIsOpen] = useState(false);
  const callback = useCallback((tab) => {
    setActiveTab(tab); 
  }, []);
  
  const [isPrepopulatedDataIn, setIsPrepopulatedDataIn] = useState(false);
  const [pinagareSupervisorList, setPinagareSupervisorList] = useState([]);
  const [pinagareMinistires, setPinagareMinistires] = useState([]);

  useEffect(() => {

   
    if(!isPrepopulatedDataIn){
    
      const body_t=JSON.stringify({
        
        omang:localStorage.getItem('username'),
        eng:'fetch_pinagare_supervisor_list',       
        
      });

      trackPromise(
          pinagareFetchRequest(pinagareAPIURL,body_t)
      );  
  
    }

      
  }, [isPrepopulatedDataIn]);

  async function pinagareFetchRequest(url,body) {//alert('d');
    
    try {
      
      await fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: body,
      })
        .then((respose) => {
          if (respose.ok) {
        
            return respose.json()
          }
          throw new Error('error')
        })
        .then((data) => {
  
        //alert(eng);
        //console.log(JSON.stringify(data)+" --"); 
          if (data.status!=null&&data.status!=undefined&&data.status) {
  
          
          
                //toast.success("Data fetch Successfull");

                setPinagareSupervisorList(data.supervisors);               
                
                setPinagareMinistires(data.ministries);

                setIsPrepopulatedDataIn(true);
        
                         
          } else {
            
  
            if(data.status==false){

                toast.error(data.message);
              
            }
            else{             
              
                toast.error(" Network Error occurred... Could not fetch data.");
            
            }
           
           setIsPrepopulatedDataIn(false);

          }
        })
        //.then((error) => {//alert(JSON.stringify(error));
       // })
  
     
    } catch (error) {
      //console.log(JSON.stringify(error)+" --"); 
      toast.error("Network Error occurred.. Could not fetch data.."+JSON.stringify(error));
      setIsPrepopulatedDataIn(false);
    }
  
  }

  return (
    <Fragment>
      <Col xl='3' className='box-col-6'>
        <div className='md-sidebar'>
          <Btn attrBtn={{ onClick: (e) => setIsOpen(!isOpen), color: 'primary', className: 'md-sidebar-toggle' }}>Supervisor Filter</Btn>
          <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${isOpen && 'open'}`}>
            <div className='email-sidebar'>
              <div className={`email-left-aside`}>
                <Card>
                  <CardBody>
                    <div className='email-app-sidebar left-bookmark'>
                      <HeaderProfile />
                      <NavComponent pinagareMinistires={pinagareMinistires} callbackActive={callback} />
                    </div>
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </Col>
      <Col xl='9' md='12' className='box-col-12'>
        <div className='email-right-aside bookmark-tabcontent contacts-tabs'>
          <div className='email-body radius-left'>
            <div className='ps-0'>
              <TabComponent pinagareSupervisorList={pinagareSupervisorList} activeTab={activeTab} />
            </div>
          </div>
        </div>
      </Col>
    </Fragment>
  );
};

export default LeftContact;
